import styled from "styled-components";
import { List } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

export const OuterList = styled(List)<{ flex?: number }>`
    flex: ${({ flex = 1 }): number => flex};
`;

export const InnerList = styled(List)<{
    width?: string;
}>`
    flex-direction: row;
    display: flex;
    width: ${({ width = "100%" }): string => width};
    padding: 0;
`;

export const useListStyles = makeStyles({
    row: {
        padding: "0 0 5px 0",
        display: "flex",
        alignItems: "flex-start",
    },
});

export const useListHeaderStyles = makeStyles({
    header: {
        display: "flex",
        padding: 0,
    },
    row: {
        padding: 0,
    },
});

export const useFilterListStyles = makeStyles((theme) => ({
    row: {
        padding: 0,
    },
    smallListItem: {
        flex: 1,
    },
    mediumListItem: {
        flex: 2,
    },
    chipContainer: {
        margin: 0,
    },
    chip: {
        marginRight: theme.spacing(0.5),
    },
}));

export const useCreativeMappingsFormStyles = makeStyles({
    row: {
        padding: "0 0 5px 0",
        display: "flex",
        alignItems: "flex-start",
        flex: 1,
    },
});
